// Shared discount rule options
// This file exists to break circular dependencies between DiscountRule and MSODiscountRule inputs

// Discount type options for the editor dropdown (new rules)
// NOTE: Only showing primary types. Legacy types still work in backend for backward compatibility.
export const discountTypeOptions = [
  { label: "Sale Pricing", code: "salePricing" },
  { label: "Coupon", code: "coupon" },
  { label: "Bundle", code: "bundle" },
];

// All discount types for filtering (includes legacy types for viewing existing rules)
export const discountTypeFilterOptions = [
  { label: "Sale Pricing", code: "salePricing" },
  { label: "Coupon", code: "coupon" },
  { label: "Bundle", code: "bundle" },
];

// Day of week options
export const dayOfWeekOptions = [
  { label: "Sunday", code: 0 },
  { label: "Monday", code: 1 },
  { label: "Tuesday", code: 2 },
  { label: "Wednesday", code: 3 },
  { label: "Thursday", code: 4 },
  { label: "Friday", code: 5 },
  { label: "Saturday", code: 6 },
];

// Source type options
export const sourceTypeOptions = [
  { label: "POS", code: "pos" },
  { label: "Online Store", code: "online-store" },
  { label: "Kiosk", code: "kiosk" },
];

// Effect type options
export const effectTypeOptions = [
  { label: "Percent Off", code: "PERCENT_OFF" },
  { label: "Dollar Off", code: "DOLLAR_OFF" },
  { label: "Fixed Price", code: "FIXED_PRICE" },
  { label: "Free", code: "FREE" },
];

// Apply to options (must match backend enum: 'all', 'cheapest', 'most_expensive')
export const applyToOptions = [
  { label: "All Matching Items", code: "all" },
  { label: "Cheapest First", code: "cheapest" },
  { label: "Most Expensive First", code: "most_expensive" },
];

// Condition field options
export const conditionFieldOptions = [
  { label: "Product", code: "product._id" },
  { label: "Product Group", code: "product.group" },
  { label: "Product Supplier", code: "product.supplier" },
  { label: "Product Brand", code: "product.brand" },
  { label: "Cannabis Size (g)", code: "product.cannabisGramsUnit" },
  { label: "Unit Price", code: "item.unitPrice" },
  { label: "Days Until Expiry", code: "item.daysUntilExpiry" },
  { label: "Days Since Purchase", code: "item.daysSincePurchase" },
  { label: "Cart Subtotal", code: "cart.subTotal" },
  { label: "Cart Item Count", code: "cart.itemCount" },
  { label: "Cart Cannabis Grams", code: "cart.cannabisGrams" },
  // { label: "Day of Week", code: "time.dayOfWeek" },
  // { label: "Hour of Day", code: "time.hour" },
];

// Customer condition field options (for triggers.customerConditions)
export const customerConditionFieldOptions = [
  { label: "Is Veteran", code: "customer.isVeteran" },
  { label: "Visit Count", code: "customer.visitCount" },
  { label: "First Time Customer", code: "customer.firstPurchase" },
  { label: "Loyalty Points", code: "customer.loyaltyPoints" },
  { label: "Member Since (days)", code: "customer.memberDays" },
];

// Condition operator options
export const conditionOperatorOptions = [
  { label: "Equals", code: "eq" },
  { label: "Not Equals", code: "neq" },
  { label: "Greater Than", code: "gt" },
  { label: "Greater Than or Equal", code: "gte" },
  { label: "Less Than", code: "lt" },
  { label: "Less Than or Equal", code: "lte" },
  { label: "In List", code: "in" },
  { label: "Not In List", code: "nin" },
];

// Stacking behavior options
export const stackingBehaviorOptions = [
  { label: "Use Store Default", code: "default" },
  { label: "Stack With All", code: "stackWithAll" },
  { label: "Exclusive (No Stacking)", code: "exclusive" },
  { label: "Custom", code: "custom" },
];

// Default effect
export const defaultEffect = {
  type: "PERCENT_OFF",
  value: 0,
  maxQuantity: 0,
  applyTo: "all",
  targetConditions: null,
};

// Default condition
export const defaultCondition = {
  field: "",
  operator: "eq",
  value: "",
};

// Default condition group
export const defaultConditionGroup = {
  type: "AND",
  rules: [],
};

// Default bundle group (for bundle type discounts)
export const defaultBundleGroup = {
  label: "",
  conditions: {
    type: "AND",
    rules: [],
  },
  requiredQuantity: 1,
};
